import { ApplicationInsights } from '@microsoft/1ds-analytics-web-js';
import { AuthPlugin, AuthType } from '@microsoft/1ds-auth-js';
import * as appConfig from '@shared/services/init/appConfig';
import { PropertiesPlugin } from '@microsoft/1ds-properties-js';
import { CorrelationVectorPlugin } from '@microsoft/1ds-cv-js';
import { getWindow } from '@shared/services/window';
import { Constants, Environment, OneDSEnvs } from '@shared/utils/constants';
import { getGPCValue } from '@shared/utils/privacyUtils';
const envsMap = {
    [Environment.Production]: OneDSEnvs.Production,
    [Environment.Canary]: OneDSEnvs.Canary,
    [Environment.Development]: OneDSEnvs.Internal,
    [Environment.Dogfood]: OneDSEnvs.Dogfood,
    [Environment.Test]: OneDSEnvs.Test
};
const getEnvName = ()=>{
    var _getWindow___INITIAL_STATE___config_siteEnvironment, _getWindow___INITIAL_STATE___config, _getWindow___INITIAL_STATE__, _getWindow;
    var _getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase;
    const siteEnvironment = (_getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config = _getWindow___INITIAL_STATE__.config) === null || _getWindow___INITIAL_STATE___config === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config_siteEnvironment = _getWindow___INITIAL_STATE___config.siteEnvironment) === null || _getWindow___INITIAL_STATE___config_siteEnvironment === void 0 ? void 0 : _getWindow___INITIAL_STATE___config_siteEnvironment.toLowerCase()) !== null && _getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase !== void 0 ? _getWindow___INITIAL_STATE___config_siteEnvironment_toLowerCase : process.env.siteEnvironment;
    const env = envsMap[`${siteEnvironment}`];
    if (!env) {
        throw new Error('failed to load env name for telemetry');
    }
    return env;
};
const initiate1DS = ()=>{
    var _getWindow___INITIAL_STATE___config, _getWindow___INITIAL_STATE__, _getWindow, _getWindow___INITIAL_STATE___config1, _getWindow___INITIAL_STATE__1, _getWindow1;
    const analytics = new ApplicationInsights();
    const authPlugin = new AuthPlugin();
    const propertiesPlugin = new PropertiesPlugin();
    const cvPlugin = new CorrelationVectorPlugin();
    const webAnalyticsConfig = {
        urlCollectQuery: true,
        urlCollectHash: true,
        // Web Analytics Plugin configuration
        autoCapture: {
            scroll: true,
            pageView: true,
            onLoad: true,
            onUnload: true,
            click: true,
            resize: true,
            lineage: true,
            jsError: true
        },
        shareAuthStatus: true,
        callback: {
            signedinStatus: ()=>{
                var _getWindow___INITIAL_STATE___users, _getWindow___INITIAL_STATE__, _getWindow;
                var _getWindow___INITIAL_STATE___users_signedIn;
                return (_getWindow___INITIAL_STATE___users_signedIn = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___users = _getWindow___INITIAL_STATE__.users) === null || _getWindow___INITIAL_STATE___users === void 0 ? void 0 : _getWindow___INITIAL_STATE___users.signedIn) !== null && _getWindow___INITIAL_STATE___users_signedIn !== void 0 ? _getWindow___INITIAL_STATE___users_signedIn : false;
            }
        }
    };
    const authConfig = {
        authType: AuthType.AAD,
        loggedInStatusCallback: ()=>{
            var _getWindow___INITIAL_STATE___users, _getWindow___INITIAL_STATE__, _getWindow;
            var _getWindow___INITIAL_STATE___users_signedIn;
            return (_getWindow___INITIAL_STATE___users_signedIn = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___users = _getWindow___INITIAL_STATE__.users) === null || _getWindow___INITIAL_STATE___users === void 0 ? void 0 : _getWindow___INITIAL_STATE___users.signedIn) !== null && _getWindow___INITIAL_STATE___users_signedIn !== void 0 ? _getWindow___INITIAL_STATE___users_signedIn : false;
        }
    };
    var _getGPCValue;
    const propertiesPluginConfig = {
        populateBrowserInfo: true,
        populateOperatingSystemInfo: true,
        enableApplicationInsightsTrace: true,
        enableApplicationInsightsUser: true,
        userConsentCookieName: Constants.Cookies.privacyConsentAcceptedDate,
        env: getEnvName(),
        // eslint-disable-next-line camelcase
        gpcDataSharingOptIn: (_getGPCValue = getGPCValue()) !== null && _getGPCValue !== void 0 ? _getGPCValue : true,
        callback: {
            userConsentDetails: ()=>appConfig.get('siteConsent')
        }
    };
    const config = {
        propertyConfiguration: propertiesPluginConfig,
        instrumentationKey: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config = _getWindow___INITIAL_STATE__.config) === null || _getWindow___INITIAL_STATE___config === void 0 ? void 0 : _getWindow___INITIAL_STATE___config.telemetryInstrumentationKey,
        endpointUrl: (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : (_getWindow___INITIAL_STATE__1 = _getWindow1.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__1 === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config1 = _getWindow___INITIAL_STATE__1.config) === null || _getWindow___INITIAL_STATE___config1 === void 0 ? void 0 : _getWindow___INITIAL_STATE___config1.telemetryEndpoint,
        webAnalyticsConfiguration: webAnalyticsConfig,
        extensions: [
            authPlugin,
            propertiesPlugin,
            cvPlugin
        ],
        extensionConfig: {
            [authPlugin.identifier]: authConfig,
            [propertiesPlugin.identifier]: propertiesPluginConfig
        },
        perfEvtsSendAll: true
    };
    analytics.initialize(config, []);
    return analytics;
};
export default (()=>__CLIENT__ && initiate1DS());
